import { useQuery } from "@tanstack/react-query";
import { AIAgentBedrock } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useBedrockRegions = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["ai-bedrock-regions"],
    queryFn: () => defaultOnError(AIAgentBedrock.regions(), "Loading AWS regions failed", "Could not load AWS regions")
  });
  return { data: data != null ? data : [], isLoading };
};
export default useBedrockRegions;
